import * as React from 'react';
import { Route } from 'react-router';
import App from 'app/components/App';
import RequireUnauth from 'lib/RequireUnauth';
import { RequireUserFn } from 'lib/RequireUser';
import ShareSDKLogin from './components/ShareSDKLogin';
import NotFoundPage from 'app/components/NotFoundPage';
import ShareSDKComposer from './components/ShareSDKComposer';
import ShareSDKLoginPopup from './components/ShareSDKLoginPopup';
import NoCookies from './components/ShareSDKNoCookies';

export const LOGIN_PATH = '/share_sdk/log_in';
export const COMPOSER_PATH = '/share_sdk/composer';
export const LOGIN_POP_PATH = '/share_sdk/log_in/popup';

// eslint-disable-next-line no-restricted-globals
const requireAuthen = RequireUserFn({ location: LOGIN_PATH + location.search });
const requireUnauth = RequireUnauth({ location: COMPOSER_PATH });

export default (
  <Route>
    <Route path="/share_sdk/noCookies" component={NoCookies} />
    <Route component={App} onEnter={App.onEnter} onChange={App.onChange}>
      {/* @ts-expect-error */}
      <Route path={COMPOSER_PATH} components={ShareSDKComposer} onEnter={requireAuthen} />
      {/* @ts-expect-error */}
      <Route path={LOGIN_PATH} components={ShareSDKLogin} onEnter={requireUnauth} />
      {/* @ts-expect-error */}
      <Route path={LOGIN_POP_PATH} components={ShareSDKLoginPopup} />
      <Route path="*" component={NotFoundPage} />
    </Route>
  </Route>
);
